import React, { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeData, setThemeData] = useState(() => {
    return JSON.parse(localStorage.getItem("themeData")) || {
      primary_color: "#49adff",
      background_color_primary: "#fff",
      topbar_color: "#fff",
      logo: "",
    };
  });

  useEffect(() => {
    applyTheme(themeData);
  }, [themeData]);

  const applyTheme = (theme) => {
    document.documentElement.style.setProperty("--primary-color", theme.primary_color);
    document.documentElement.style.setProperty("--secondary-color", theme.background_color_primary);
    document.documentElement.style.setProperty("--topbar-color", theme.topbar_color);
  };

  const updateTheme = (newTheme) => {
    localStorage.setItem("themeData", JSON.stringify(newTheme));
    setThemeData(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ themeData, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
